// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type { GptAssistantAsyncResult } from "./types";

const nullableString = anyOf(string, nullValidation);
const nullableStringOrStrings = anyOf(string, arrayOf(string), nullValidation);

export const isGptAssistantAsyncResult = objectOf<GptAssistantAsyncResult>({
  status: number,
  response: maybe(nullableStringOrStrings),
  error: maybe(nullableString),
  model: maybe(nullableString),
  on_brand_failed_warning: maybe(boolean),
  error_code: maybe(string),
});
